import {
  aRuleTagOption,
  mockRuleTagOptionsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockRuleTagOptionsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          ruleTagOptions: [
            aRuleTagOption({
              value: 'TA0009',
              label: null,
            }),
          ],
        },
      });
    }
  ),
];
